<template>
  <NoDataTable v-if="!dataDetails.companyname" />
  <div v-else-if="dataDetails.companyname && dataDetails.status !== 201">
    <div class="header-flex">
      <div class="header-title">
        <h3>{{ dataDetails.companyname }}</h3>
        <h5>{{ dataDetails.remark }}</h5>
        <h4>
          {{ convertDateReportFormat(dataDetails.dateFrom, dataDetails.dateTo) }}
        </h4>
      </div>
      <input type="button" value="Download Excel" @click="exportTableToExcel" />
    </div>

    <div class="main-table">
      <table id="excelDownload">
        <thead>
          <tr>
            <th rowspan="3" class="th-one-freeze">Particular Date</th>
            <th rowspan="3" class="th-two-freeze">Total Number Active</th>
            <th rowspan="3" class="th-three-freeze">Total IWC Shares</th>
            <th colspan="2">IN-PATIENT</th>
            <th colspan="6">OUT-PATIENT</th>
            <th colspan="2">FREE</th>
            <th colspan="2">APE</th>
            <th colspan="2" v-if="showSpecialAccommodation">SPECIAL ACCOMMODATION</th>
            <th rowspan="3">{{ availmentLabel }} (COUNT)</th>
            <th rowspan="3">{{ availmentLabel }} (AMOUNT)</th>
            <th rowspan="3">IP AMOUNT %</th>
            <th rowspan="3">OP AMOUNT %</th>
            <th rowspan="3">FREE AMOUNT %</th>
            <th rowspan="3">APE AMOUNT %</th>
            <th rowspan="3" v-if="showSpecialAccommodation">SPECIAL ACCOMMODATION AMOUNT %</th>
            <th rowspan="3">OVERALL %</th>
          </tr>
          <tr>
            <th rowspan="2">Total Count</th>
            <th rowspan="2">Total Amount</th>
            <th colspan="2">Consultation</th>
            <th colspan="2">Laboratory</th>
            <th colspan="2">Other OP</th>
            <th rowspan="2">Total Count</th>
            <th rowspan="2">Total Amount</th>
            <th rowspan="2">Total Count</th>
            <th rowspan="2">Total Amount</th>
            <th rowspan="2" v-if="showSpecialAccommodation">Total Count</th>
            <th rowspan="2" v-if="showSpecialAccommodation">Total Amount</th>
          </tr>
          <tr>
            <th colspan="1">Total Count</th>
            <th colspan="1">Total Amount</th>
            <th colspan="1">Total Count</th>
            <th colspan="1">Total Amount</th>
            <th colspan="1">Total Count</th>
            <th colspan="1">Total Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in modifiedDataHandler" :key="index">
            <td class="col-span-max td-one-freeze">{{ item["Month"] }}</td>
            <td class="col-span-1 td-two-freeze">
              {{ convertNumberFormat(item["Active Members"]) }}
            </td>
            <td class="col-span-1 td-three-freeze">
              {{ convertAmountFormat(item["Remittance"]) }}
            </td>
            <td class="col-span-2">
              {{ convertNumberFormat(item["IPCount"]) }}
            </td>
            <td class="col-span-2">
              {{ convertAmountFormat(item["IPAmount"]) }}
            </td>
            <td class="col-span-2">
              {{ convertNumberFormat(item["Cons. Count"]) }}
            </td>
            <td class="col-span-2">
              {{ convertAmountFormat(item["Cons. Amount"]) }}
            </td>
            <td class="col-span-2">
              {{ convertNumberFormat(item["Lab. Count"]) }}
            </td>
            <td class="col-span-2">
              {{ convertAmountFormat(item["Lab. Amount"]) }}
            </td>
            <td class="col-span-2">
              {{ convertNumberFormat(item["Other OP Count"]) }}
            </td>
            <td class="col-span-2">
              {{ convertAmountFormat(item["Other OP Amount"]) }}
            </td>
            <td class="col-span-2">
              {{ convertNumberFormat(item["Free Cons. Count"]) }}
            </td>
            <td class="col-span-2">
              {{ convertAmountFormat(item["Free Cons. Amount"]) }}
            </td>
            <td class="col-span-2">
              {{ convertNumberFormat(item["APE Count"]) }}
            </td>
            <td class="col-span-2">
              {{ convertAmountFormat(item["APE Amount"]) }}
            </td>
            <td class="col-span-2" v-if="showSpecialAccommodation">
              {{ convertNumberFormat(item["Special Accomodation Count"]) }}
            </td>
            <td class="col-span-2" v-if="showSpecialAccommodation">
              {{ convertAmountFormat(item["Special Accomodation Amount"]) }}
            </td>
            <td class="col-span-1">
              {{ convertNumberFormat(item["IP + OP + APE + SPECIAL ACCOMODATION (Count)"]) }}
            </td>
            <td class="col-span-1">
              {{ convertAmountFormat(item["IP + OP + APE + SPECIAL ACCOMODATION (Amount)"]) }}
            </td>
            <td class="col-span-1">
              {{ item["IP Amount %"] }}
            </td>
            <td class="col-span-1">
              {{ item["OP Amount %"] }}
            </td>
            <td class="col-span-1">{{ item["Free Cons. Amount %"] }}</td>
            <td class="col-span-1">{{ item["APE Amount %"] }}</td>
            <td class="col-span-1" v-if="showSpecialAccommodation">{{ item["Special Accomodation Amount %"] }}</td>
            <td class="col-span-1">{{ item["Overall %"] }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="footer">
            <td colspan="2" class="td-one-freeze">TOTAL</td>
            <td class="td-two-freeze td-three-freeze">
              {{ totalRemittance(modifiedDataHandler) }}
            </td>
            <td>{{ totalIPCount(modifiedDataHandler) }}</td>
            <td>{{ totalIPAmount(modifiedDataHandler) }}</td>
            <td>{{ totalConsultationCount(modifiedDataHandler) }}</td>
            <td>{{ totalConsultationAmount(modifiedDataHandler) }}</td>
            <td>{{ totalLaboratoryCount(modifiedDataHandler) }}</td>
            <td>{{ totalLaboratoryAmount(modifiedDataHandler) }}</td>
            <td>{{ totalOtherOPCount(modifiedDataHandler) }}</td>
            <td>{{ totalOtherOPAmount(modifiedDataHandler) }}</td>
            <td>{{ totalFreeCount(modifiedDataHandler) }}</td>
            <td>{{ totalFreeAmount(modifiedDataHandler) }}</td>
            <td>{{ totalAPECount(modifiedDataHandler) }}</td>
            <td>{{ totalAPEAmount(modifiedDataHandler) }}</td>
            <td v-if="showSpecialAccommodation">{{ totalSpecialAccomodationCount(modifiedDataHandler) }}</td>
            <td v-if="showSpecialAccommodation">{{ totalSpecialAccomodationAmount(modifiedDataHandler) }}</td>
            <td>{{ totalAvailmentTypeCount(modifiedDataHandler) }}</td>
            <td>{{ totalAvailmentTypeAmount(modifiedDataHandler) }}</td>
            <td>{{ percentageIPAmount(modifiedDataHandler) }}</td>
            <td>{{ percentageOPAmount(modifiedDataHandler) }}</td>
            <td>{{ percentageFreeAmount(modifiedDataHandler) }}</td>
            <td>{{ percentageAPEAmount(modifiedDataHandler) }}</td>
            <td v-if="showSpecialAccommodation">{{ percentageSpecialAccomAmount(modifiedDataHandler) }}</td>
            <td>{{ percentageOverAll(modifiedDataHandler) }}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
  <div v-else>
    <div class="header-title">
      <h3>{{ dataDetails.companyname }}</h3>
      <h4>
        {{ convertDateReportFormat(dataDetails.dateFrom, dataDetails.dateTo) }}
      </h4>
    </div>
    <NotFoundDataTable />
  </div>
</template>

<script>
import UsedFormatUtils from "@/utils/format";
import { computed, inject, watch } from "vue";
import ExcelJS from "exceljs";

export default {
  props: {
    dataResult: Object,
    dataDetails: Object,
    searchData: String,
  },
  setup(props) {
    const moment = inject("$moment");
    const { convertAmountFormat, convertNumberFormat, convertDateReportFormat } = UsedFormatUtils();

    // Whether to show the SPECIAL ACCOMMODATION columns at all
    const showSpecialAccommodation = computed(() => props.dataDetails.remark !== "Without Special Accommodation");

    // Dynamic label for the combined availment columns
    const availmentLabel = computed(() => (showSpecialAccommodation.value ? "IP + OP + APE + SPECIAL ACCOMMODATION" : "IP + OP + APE"));

    const modifiedDataHandler = computed(() => {
      let dataItems = props.dataResult;
      let search = (props.searchData || "").toLowerCase().trim();

      let resultData = dataItems.filter((val) => {
        return val.Month?.toLowerCase().includes(search);
      });
      return resultData;
    });
    const totalRemittance = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val.Remittance.replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-PH", {
          style: "currency",
          currency: "PHP",
        });
      return total;
    };
    const totalIPCount = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["IPCount"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-US");
      return total;
    };
    const totalIPAmount = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["IPAmount"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-PH", {
          style: "currency",
          currency: "PHP",
        });
      return total;
    };
    const totalConsultationCount = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["Cons. Count"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-US");
      return total;
    };

    const totalConsultationAmount = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["Cons. Amount"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-PH", {
          style: "currency",
          currency: "PHP",
        });
      return total;
    };
    const totalLaboratoryCount = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["Lab. Count"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-US");
      return total;
    };
    const totalLaboratoryAmount = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["Lab. Amount"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-PH", {
          style: "currency",
          currency: "PHP",
        });
      return total;
    };

    const totalOtherOPCount = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["Other OP Count"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-US");
      return total;
    };

    const totalOtherOPAmount = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["Other OP Amount"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-PH", {
          style: "currency",
          currency: "PHP",
        });
      return total;
    };

    const totalAPECount = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["APE Count"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-US");
      return total;
    };

    const totalAPEAmount = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["APE Amount"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-PH", {
          style: "currency",
          currency: "PHP",
        });
      return total;
    };

    const totalSpecialAccomodationCount = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["Special Accomodation Count"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-US");
      return total;
    };
    const totalSpecialAccomodationAmount = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["Special Accomodation Amount"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-PH", {
          style: "currency",
          currency: "PHP",
        });
      return total;
    };

    const totalFreeCount = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["Free Cons. Count"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-US");
      return total;
    };

    const totalFreeAmount = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["Free Cons. Amount"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-PH", {
          style: "currency",
          currency: "PHP",
        });
      return total;
    };

    const totalAvailmentTypeCount = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["IP + OP + APE + SPECIAL ACCOMODATION (Count)"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-US");
      return total;
    };

    const totalAvailmentTypeAmount = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["IP + OP + APE + SPECIAL ACCOMODATION (Amount)"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-PH", {
          style: "currency",
          currency: "PHP",
        });
      return total;
    };

    const percentageIPAmount = (val) => {
      let resultData = val;
      let totalAmountIP = resultData.map((val) => parseFloat(val["IPAmount"].replace(/,/g, "")) || 0).reduce((sum, total) => sum + total, 0);

      let totalAmountRemittance = resultData.map((val) => parseFloat(val.Remittance.replace(/,/g, "")) || 0).reduce((sum, total) => sum + total, 0);

      let result = `${((totalAmountIP / totalAmountRemittance) * 100).toFixed(2)}%`;

      return result;
    };

    const percentageOPAmount = (val) => {
      let resultData = val;

      let totalAmountConsultation = resultData.map((val) => parseFloat(val["Cons. Amount"].replace(/,/g, "")) || 0).reduce((sum, total) => sum + total, 0);

      let totalAmountLaboratory = resultData.map((val) => parseFloat(val["Lab. Amount"].replace(/,/g, "")) || 0).reduce((sum, total) => sum + total, 0);

      let totalAmountOthers = resultData.map((val) => parseFloat(val["Other OP Amount"].replace(/,/g, "")) || 0).reduce((sum, total) => sum + total, 0);

      let totalAmountRemittance = resultData.map((val) => parseFloat(val.Remittance.replace(/,/g, "")) || 0).reduce((sum, total) => sum + total, 0);

      let totalOPAmount = totalAmountConsultation + totalAmountLaboratory + totalAmountOthers;

      let result = `${((totalOPAmount / totalAmountRemittance) * 100).toFixed(2)}%`;
      return result;
    };

    const percentageFreeAmount = (val) => {
      let resultData = val;
      let totalFreeAmount = resultData.map((val) => parseFloat(val["Free Cons. Amount"].replace(/,/g, "")) || 0).reduce((sum, total) => sum + total, 0);

      let totalAmountRemittance = resultData.map((val) => parseFloat(val.Remittance.replace(/,/g, "")) || 0).reduce((sum, total) => sum + total, 0);

      let result = `${((totalFreeAmount / totalAmountRemittance) * 100).toFixed(2)}%`;

      return result;
    };

    const percentageAPEAmount = (val) => {
      let resultData = val;
      let totalAPEAmount = resultData.map((val) => parseFloat(val["APE Amount"].replace(/,/g, "")) || 0).reduce((sum, total) => sum + total, 0);

      let totalAmountRemittance = resultData.map((val) => parseFloat(val.Remittance.replace(/,/g, "")) || 0).reduce((sum, total) => sum + total, 0);

      let result = `${((totalAPEAmount / totalAmountRemittance) * 100).toFixed(2)}%`;

      return result;
    };

    const percentageSpecialAccomAmount = (val) => {
      let resultData = val;
      let totalAPEAmount = resultData.map((val) => parseFloat(val["APE Amount"].replace(/,/g, "")) || 0).reduce((sum, total) => sum + total, 0);

      let totalAmountRemittance = resultData.map((val) => parseFloat(val.Remittance.replace(/,/g, "")) || 0).reduce((sum, total) => sum + total, 0);

      let result = `${((totalAPEAmount / totalAmountRemittance) * 100).toFixed(2)}%`;

      return result;
    };
    const percentageOverAll = (val) => {
      let resultData = val;
      let totalAvailmentAmount = resultData
        .map((val) => parseFloat(val["IP + OP + APE + SPECIAL ACCOMODATION (Amount)"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0);

      let totalAmountRemittance = resultData.map((val) => parseFloat(val.Remittance.replace(/,/g, "")) || 0).reduce((sum, total) => sum + total, 0);

      let result = `${((totalAvailmentAmount / totalAmountRemittance) * 100).toFixed(2)}%`;

      return result;
    };
    watch(() => props.searchData, modifiedDataHandler);

    const exportTableToExcel = async () => {
      const table = document.getElementById("excelDownload");
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Sheet1");
      const showSA = showSpecialAccommodation.value;

      // Add Title (A1)
      worksheet.getCell("A1").value = "Company Utilization Report";
      worksheet.getCell("A1").font = { bold: true, size: 13 };
      worksheet.getCell("A1").alignment = {
        horizontal: "left",
        vertical: "middle",
      };

      // Add Subtitle (A2)
      worksheet.getCell("A2").value = props.dataDetails.companyname;
      worksheet.getCell("A2").font = { bold: true, size: 12 };
      worksheet.getCell("A2").alignment = {
        horizontal: "left",
        vertical: "middle",
      };

      // Add Subtitle (A3) - remark, shown right after the company name
      worksheet.getCell("A3").value = props.dataDetails.remark;
      worksheet.getCell("A3").font = { bold: false, size: 12 };
      worksheet.getCell("A3").alignment = {
        horizontal: "left",
        vertical: "middle",
      };

      // Add Subtitle (A4)
      worksheet.getCell("A4").value = `Coverage Range:  ${convertDateReportFormat(props.dataDetails.dateFrom, props.dataDetails.dateTo)}`;
      worksheet.getCell("A4").font = { bold: false, size: 12 };
      worksheet.getCell("A4").alignment = {
        horizontal: "left",
        vertical: "middle",
      };

      // Add Subtitle (A5)
      worksheet.getCell("A5").value = `Extracted Date: ${moment().format("MMMM D, YYYY | h:mmA")}`;
      worksheet.getCell("A5").font = { bold: false, size: 12 };
      worksheet.getCell("A5").alignment = {
        horizontal: "left",
        vertical: "middle",
      };
      // Leave a row empty for spacing before table
      worksheet.addRow([]);

      // --- Dynamic column layout (1-based column numbers) ---
      // 1 Particular Date | 2 Active | 3 IWC Shares
      // 4-5 IN-PATIENT | 6-11 OUT-PATIENT | 12-13 FREE | 14-15 APE
      // [showSA] 16-17 SPECIAL ACCOMMODATION
      const availCol = showSA ? 18 : 16; // Avail Count column; Avail Amount is availCol + 1
      const ipPctCol = availCol + 2;
      const opPctCol = ipPctCol + 1;
      const freePctCol = opPctCol + 1;
      const apePctCol = freePctCol + 1;
      const saPctCol = showSA ? apePctCol + 1 : null;
      const overallPctCol = (showSA ? saPctCol : apePctCol) + 1;
      const totalColumnCount = overallPctCol;

      const headerRow1 = new Array(totalColumnCount).fill("");
      const headerRow2 = new Array(totalColumnCount).fill("");
      const headerRow3 = new Array(totalColumnCount).fill("");

      headerRow1[0] = "Particular Date";
      headerRow1[1] = "Total Number Active";
      headerRow1[2] = "Total IWC Shares";
      headerRow1[3] = "IN-PATIENT";
      headerRow1[5] = "OUT-PATIENT";
      headerRow1[11] = "FREE";
      headerRow1[13] = "APE";
      if (showSA) headerRow1[15] = "SPECIAL ACCOMMODATION";
      headerRow1[availCol - 1] = `${showSA ? "IP + OP + APE + SPECIAL ACCOMMODATION" : "IP + OP + APE"} (COUNT)`;
      headerRow1[availCol] = `${showSA ? "IP + OP + APE + SPECIAL ACCOMMODATION" : "IP + OP + APE"} (AMOUNT)`;
      headerRow1[ipPctCol - 1] = "IP AMOUNT %";
      headerRow1[opPctCol - 1] = "OP AMOUNT %";
      headerRow1[freePctCol - 1] = "FREE AMOUNT %";
      headerRow1[apePctCol - 1] = "APE AMOUNT %";
      if (showSA) headerRow1[saPctCol - 1] = "SPECIAL ACCOMMODATION AMOUNT %";
      headerRow1[overallPctCol - 1] = "OVERALL %";

      headerRow2[3] = "Total Count";
      headerRow2[4] = "Total Amount";
      headerRow2[5] = "Consultation";
      headerRow2[7] = "Laboratory";
      headerRow2[9] = "Other OP";
      headerRow2[11] = "Total Count";
      headerRow2[12] = "Total Amount";
      headerRow2[13] = "Total Count";
      headerRow2[14] = "Total Amount";
      if (showSA) {
        headerRow2[15] = "Total Count";
        headerRow2[16] = "Total Amount";
      }

      headerRow3[5] = "Total Count";
      headerRow3[6] = "Total Amount";
      headerRow3[7] = "Total Count";
      headerRow3[8] = "Total Amount";
      headerRow3[9] = "Total Count";
      headerRow3[10] = "Total Amount";

      worksheet.addRow(headerRow1);
      worksheet.addRow(headerRow2);
      worksheet.addRow(headerRow3);

      const HR = 7; // header start row (shifted down 1 for the remark row)

      worksheet.mergeCells(HR, 1, HR + 2, 1);
      worksheet.mergeCells(HR, 2, HR + 2, 2);
      worksheet.mergeCells(HR, 3, HR + 2, 3);
      worksheet.mergeCells(HR, 4, HR, 5);
      worksheet.mergeCells(HR, 6, HR, 11);
      worksheet.mergeCells(HR, 12, HR, 13);
      worksheet.mergeCells(HR, 14, HR, 15);
      if (showSA) worksheet.mergeCells(HR, 16, HR, 17);
      worksheet.mergeCells(HR, availCol, HR + 2, availCol);
      worksheet.mergeCells(HR, availCol + 1, HR + 2, availCol + 1);
      worksheet.mergeCells(HR, ipPctCol, HR + 2, ipPctCol);
      worksheet.mergeCells(HR, opPctCol, HR + 2, opPctCol);
      worksheet.mergeCells(HR, freePctCol, HR + 2, freePctCol);
      worksheet.mergeCells(HR, apePctCol, HR + 2, apePctCol);
      if (showSA) worksheet.mergeCells(HR, saPctCol, HR + 2, saPctCol);
      worksheet.mergeCells(HR, overallPctCol, HR + 2, overallPctCol);

      worksheet.mergeCells(HR + 1, 4, HR + 2, 4);
      worksheet.mergeCells(HR + 1, 5, HR + 2, 5);
      worksheet.mergeCells(HR + 1, 6, HR + 1, 7);
      worksheet.mergeCells(HR + 1, 8, HR + 1, 9);
      worksheet.mergeCells(HR + 1, 10, HR + 1, 11);
      worksheet.mergeCells(HR + 1, 12, HR + 2, 12);
      worksheet.mergeCells(HR + 1, 13, HR + 2, 13);
      worksheet.mergeCells(HR + 1, 14, HR + 2, 14);
      worksheet.mergeCells(HR + 1, 15, HR + 2, 15);
      if (showSA) {
        worksheet.mergeCells(HR + 1, 16, HR + 2, 16);
        worksheet.mergeCells(HR + 1, 17, HR + 2, 17);
      }

      // Style header rows
      for (let i = HR; i <= HR + 2; i++) {
        worksheet.getRow(i).eachCell({ includeEmpty: true }, (cell) => {
          cell.font = { bold: true };
          cell.alignment = {
            horizontal: "center",
            vertical: "middle",
            wrapText: true,
          };
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        });
      }

      // Column type sets, used to parse and format tbody/tfoot cells.
      // These follow the SAME order the cells actually appear in the DOM,
      // which already reflects the v-if visibility in the template.
      const countCols = new Set([2, 4, 6, 8, 10, 12, 14, ...(showSA ? [16] : []), availCol]);
      const currencyCols = new Set([3, 5, 7, 9, 11, 13, 15, ...(showSA ? [17] : []), availCol + 1]);
      const percentCols = new Set([ipPctCol, opPctCol, freePctCol, apePctCol, ...(showSA ? [saPctCol] : []), overallPctCol]);

      // Table body rows
      for (let row of table.querySelectorAll("tbody tr")) {
        let rowData = [];
        row.querySelectorAll("td").forEach((cell, idx) => {
          const col = idx + 1; // 1-based column number matching the layout above
          let value = cell.innerText.trim();

          if (countCols.has(col)) {
            value = Number(value.replace(/,/g, "")) || 0;
          } else if (currencyCols.has(col)) {
            value = parseFloat(value.replace(/[₱,]/g, "")) || 0; // Remove ₱ and commas
          } else if (percentCols.has(col)) {
            value = (parseFloat(value) || 0) / 100; // Convert to decimal (e.g., 50 → 0.5)
          }

          rowData.push(value);
        });

        const addedRow = worksheet.addRow(rowData);
        addedRow.eachCell((cell) => {
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        });
      }

      // Handle the Footer Row (TOTAL Row)
      const footerRow = table.querySelector("tfoot tr");
      if (footerRow) {
        // footerRow's first <td colspan="2"> is the "TOTAL" label; the rest
        // line up with columns 3..N in the layout above.
        const footerCells = [...footerRow.querySelectorAll("td")].map((cell) => cell.innerText.trim());
        const rowData = new Array(totalColumnCount).fill("");
        rowData[0] = "TOTAL";

        for (let i = 1; i < footerCells.length; i++) {
          const col = i + 2; // footerCells[1] -> column 3, footerCells[2] -> column 4, ...
          let value = footerCells[i];

          if (countCols.has(col)) {
            value = Number(String(value).replace(/,/g, "")) || 0;
          } else if (currencyCols.has(col)) {
            value = parseFloat(String(value).replace(/[₱,]/g, "")) || 0;
          } else if (percentCols.has(col)) {
            value = (parseFloat(value) || 0) / 100;
          }

          rowData[col - 1] = value;
        }

        const totalRow = worksheet.addRow(rowData);
        const totalRowIndex = totalRow.number;
        worksheet.mergeCells(totalRowIndex, 1, totalRowIndex, 2);

        totalRow.eachCell({ includeEmpty: true }, (cell) => {
          cell.font = { bold: true };
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "95FFC4" }, // Yellow
          };
        });

        worksheet.getCell(totalRowIndex, 1).alignment = {
          horizontal: "center",
          vertical: "middle",
        };
      }

      // Apply Number Formatting
      currencyCols.forEach((col) => (worksheet.getColumn(col).numFmt = `"₱"#,##0.00`));
      percentCols.forEach((col) => (worksheet.getColumn(col).numFmt = `0.00%`));

      worksheet.columns.forEach((column) => {
        let maxLength = 0;
        column.eachCell({ includeEmpty: true }, (cell) => {
          const cellValue = cell.value ? cell.value.toString() : "";
          maxLength = Math.max(maxLength, cellValue.length);
        });
        column.width = maxLength + 2;
      });

      // Download the Excel file
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      // Build filename as "<companyname> - <remark>.xlsx", stripping
      // characters that aren't safe in a filename.
      const safeCompanyName = (props.dataDetails.companyname || "").replace(/[\\/:*?"<>|]/g, "").trim();
      const safeRemark = (props.dataDetails.remark || "").replace(/[\\/:*?"<>|]/g, "").trim();
      const fileName = [safeCompanyName, safeRemark].filter(Boolean).join(" - ") || "table-data";

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `${fileName}.xlsx`;
      link.click();
    };

    return {
      convertAmountFormat,
      convertNumberFormat,
      convertDateReportFormat,
      showSpecialAccommodation,
      availmentLabel,
      modifiedDataHandler,
      totalRemittance,
      totalIPCount,
      totalIPAmount,
      totalConsultationCount,
      totalConsultationAmount,
      totalLaboratoryCount,
      totalLaboratoryAmount,
      totalOtherOPCount,
      totalOtherOPAmount,
      totalAPECount,
      totalAPEAmount,
      totalSpecialAccomodationCount,
      totalSpecialAccomodationAmount,
      totalFreeCount,
      totalFreeAmount,
      totalAvailmentTypeCount,
      totalAvailmentTypeAmount,
      percentageIPAmount,
      percentageOPAmount,
      percentageFreeAmount,
      percentageAPEAmount,
      percentageSpecialAccomAmount,
      percentageOverAll,
      exportTableToExcel,
    };
  },
};
</script>

<style scoped>
.header-title {
  margin-top: 18px;
}
.header-title h3 {
  color: #f37420;
}
.header-title h4 {
  color: #4e4e4e;
  font-weight: 700;
}
.col-span-max {
  min-width: 250px;
}
.col-span-1 {
  min-width: 150px;
}
.col-span-2 {
  min-width: 120px;
}
.main-table {
  overflow-x: auto;
  position: relative;
}

/* Freeze the first column (Particular Date) */
.th-one-freeze,
.td-one-freeze {
  position: sticky;
  left: 0;
  background-color: white;
  border-right: 1px solid #ddd;
}

/* Freeze the second column (Total Number Active) */
.th-two-freeze,
.td-two-freeze {
  position: sticky;
  left: 250px; /* First column width */
  background-color: white;
  border-right: 1px solid #ddd;
}

/* Freeze the third column (Total IWC Shares) */
.th-three-freeze,
.td-three-freeze {
  position: sticky;
  left: 400px; /* First column (250px) + Second column (150px) */
  background-color: white;
  border-right: 1px solid #ddd;
}

/* Ensure the header stays above table cells */
th {
  z-index: 10;
  background-color: white;
}
</style>
